import React from "react";
import "./Experience.css";

const Experience = ({ openModal }) => {
  return (
    <div className="experience">
      <div className="experienceContainer">
        <div className="cardContainer">
          <h1>Experience</h1>

          {/* Experience Card 1 */}
          <div
            className="card"
            onClick={() =>
              openModal({
                title: "Software Engineer Intern | GitHub",
                date: "May 2025 - Aug 2025",
                description:
                  "As a Software Engineer Intern at GitHub, I enhanced and developed features for internal tools used by over 500 employees in customer support and billing operations. I improved performance by updating existing Ruby-based billing menus, reducing customer response times by 20%. I also migrated critical components from the customer view to internal views, streamlining ticket handling and improving resolution time by 35%. I contributed to the creation of a Plan History feature for internal tools, providing detailed visibility into customer subscription changes and accelerating support case resolutions. Additionally, I enhanced the internal billing search interface by adding new searchable fields and optimizing SQL queries, which sped up search operations by 15%. My work ensured seamless scalability, faster workflows, and a better support experience, all while collaborating cross-functionally to maintain GitHub’s high standards.",
                technologies: ["Ruby", "Rails", "React.js", "Go", "MySQL"],
              })
            }
          >
            <h2>May 2025 - Aug 2025</h2>
            <div className="cardRight">
              <h2>Software Engineer Intern | GitHub</h2>
              <p>
                Enhanced and built features for internal tools powering the heart of GitHub Support — optimized billing workflows, migrated components, and boosted response times for 500+ employees.
              </p>
              <div>
                <li>Ruby</li>
                <li>Rails</li>
                <li>React.js</li>
                <li>Go</li>
                <li>MySQL</li>
              </div>
            </div>
          </div>

          {/* Experience Card 2 */}
          <div
            className="card"
            onClick={() =>
              openModal({
                title: "Software Engineer Intern | Breathe IT",
                date: "Nov 2024 - Feb 2025",
                description:
                  "As a Software Engineer Intern at Breathe IT, I improved app performance by identifying and addressing key bottlenecks during migration from Flutter to React Native. This resulted in significantly reduced load times through optimized code structures and efficient resource management. I designed scalable React Native components to ensure seamless migration while maintaining a high-quality user experience. Additionally, I accelerated the deployment cycle by 20% through efficient coordination and maintained performance benchmarks through effective cross-functional communication.",
                technologies: ["JavaScript", "TypeScript", "React Native", "CSS", "Node.js"],
              })
            }
          >
            <h2>Nov 2024 - Feb 2025</h2>
            <div className="cardRight">
              <h2>Software Engineer Intern | Breathe IT</h2>
              <p>
                Enhanced app performance and reduced load times by migrating
                from Flutter to React Native. Designed scalable components for seamless user experience.
              </p>
              <div>
                <li>JavaScript</li>
                <li>TypeScript</li>
                <li>React Native</li>
                <li>CSS</li>
                <li>Node.js</li>
              </div>
            </div>
          </div>

          {/* Experience Card 3 */}
          <div
            className="card"
            onClick={() =>
              openModal({
                title: "Mobile Developer Intern | Portalys",
                date: "Jul 2024 - Dec 2024",
                description:
                  "As a Mobile Developer Intern at Portalys, I contributed to the development of a cross-platform mobile application using React Native, which significantly enhanced the user experience and expanded platform functionality. I collaborated with a cross-functional team to design and optimize innovative features tailored for iOS devices, achieving improvement in development efficiency through proactive problem-solving.",
                technologies: ["JavaScript", "TypeScript", "React Native", "Figma", "CSS"],
                link: "https://apps.apple.com/nz/app/portalys-whats-the-move/id6670410649",
              })
            }
          >
            <h2>Jul 2024 - Dec 2024</h2>
            <div className="cardRight">
              <h2>Mobile Developer Intern | Portalys</h2>
              <p>
                Optimized API integration and developed a robust mobile
                application using React Native. Collaborated on innovative features for iOS devices.
              </p>
              <div>
                <li>JavaScript</li>
                <li>TypeScript</li>
                <li>React Native</li>
                <li>Figma</li>
                <li>CSS</li>
              </div>
            </div>
          </div>
        </div>

        <div className="projectContainer">
          <h1>Projects</h1>

          {/* Project Card 1 */}
          <div
            className="card"
            onClick={() =>
              openModal({
                title: "POS Mobile System",
                description:
                  "Developed a POS system aimed at small businesses to manage sales and inventory seamlessly. This system featured intuitive user interfaces and scalable functionalities built with React Native. Additionally, I integrated payment processing features and ensured data security to meet the needs of business owners. The application features an AI-powered chatbot designed to enhance the onboarding experience for first-time users.",
                technologies: [
                  "React Native",
                  "JavaScript",
                  "Express.js",
                  "Node.js",
                  "Firestore",
                  "Vercel",
                ],
                link: "https://github.com/antonioalfaroa/SunnySales-POS/blob/main/README.md",
              })
            }
          >
            <div className="cardRight">
              <h2>POS Mobile System</h2>
              <p>
                Built a POS system for small businesses with React Native.
                Designed intuitive interfaces and scalable features.
              </p>
              <div>
                <li>React Native</li>
                <li>JavaScript</li>
                <li>Express.js</li>
                <li>Node.js</li>
                <li>Firestore</li>
                <li>Vercel</li>
              </div>
            </div>
          </div>

          {/* Project Card 2 */}
          <div
            className="card"
            onClick={() =>
              openModal({
                title: "Car Dealership Database System",
                description:
                  "Designed and implemented a comprehensive database for a car dealership to efficiently manage inventory and sales records. By optimizing query performance with indexing and structured query language best practices, I achieved a 30% improvement in system management efficiency. The database ensured data integrity and supported seamless dealership operations.",
                technologies: ["MySQL", "Microsoft SQL"],
              })
            }
          >
            <div className="cardRight">
              <h2>Car Dealership Database System</h2>
              <p>
                Created a car dealership system to manage inventory and sales
                records. Focused on user-friendly design and efficient data storage.
              </p>
              <div>
                <li>MySQL</li>
                <li>Microsoft SQL</li>
              </div>
            </div>
          </div>

          {/* Project Card 3 */}
          <div
            className="card"
            onClick={() =>
              openModal({
                title: "Multifunctional App",
                description:
                  "Built a multifunctional app that integrates features like notes, calendar, and real-time weather updates. Using React.js and REST APIs, I ensured cross-platform compatibility and high performance. The app's architecture was optimized for scalability, providing users with a seamless and engaging experience across various functionalities.",
                technologies: ["JavaScript", "React.js", "REST APIs", "HTML", "CSS"],
                link: "https://github.com/antonioalfaroa/MultiFuncional-App",
              })
            }
          >
            <div className="cardRight">
              <h2>Multifunctional App</h2>
              <p>
                Developed an app with diverse functionalities for user
                engagement. Focused on cross-platform compatibility and smooth performance.
              </p>
              <div>
                <li>JavaScript</li>
                <li>React.js</li>
                <li>REST APIs</li>
                <li>HTML</li>
                <li>CSS</li>
              </div>
            </div>
          </div>

          {/* Project Card 4 */}
          <div
            className="card"
            onClick={() =>
              openModal({
                title: "Inventory System GUI",
                description:
                  "Created a graphical user interface (GUI) inventory management system to streamline business operations. Using Python and Tkinter, I developed an intuitive solution for tracking product details efficiently. The system was optimized for real-time updates and easy navigation, tailored for small to medium businesses.",
                technologies: ["Python", "Tkinter", "OOP"],
              })
            }
          >
            <div className="cardRight">
              <h2>Inventory System GUI</h2>
              <p>
                Designed a GUI for inventory management using Python.
                Prioritized usability and integration with local storage.
              </p>
              <div>
                <li>Python</li>
                <li>Tkinter</li>
                <li>OOP</li>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Experience;
